export default "__VITE_ASSET__D7evK_FT__"